module.exports = __webpack_public_path__ + "static/media/1-1.452b862c.png";